module.exports = __webpack_public_path__ + "static/img/pc-13.e9adb91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5/pc-13.jpg
// module id = l99U
// module chunks = 1